import { createContext } from 'react';
import type { Locale, TranslationKey, TranslateParams } from './types';

export interface I18nContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: TranslationKey, params?: TranslateParams) => string;
  formatDate: (value: string | Date) => string;
  formatDateTime: (value: string | Date) => string;
}

export const I18nContext = createContext<I18nContextValue | null>(null);
